import {
  type ActionCreatorWithPayload,
  createSlice,
  type PayloadAction,
} from '@reduxjs/toolkit';

import { RENDER_NORMAL } from '../../../shared/constants';
import {
  type ChatMessage,
  type ChatMode,
  type WorkflowInfo,
} from '../../../shared/types';
import {
  type ChatModuleState,
  ChatModuleType,
  type RenderModeType,
} from '../data-layer/chatModuleType';

const initialState: ChatModuleState = {
  isLoading: false,
  renderMode: RENDER_NORMAL,
  rightPanel: null,
  workflowInfo: null,
  isStreaming: false,
  scrollToStep: null,
};

const chatModuleSlice = createSlice({
  name: ChatModuleType.SLICE_NAME,
  initialState,
  reducers: {
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setRenderMode: (state, action: PayloadAction<RenderModeType>) => {
      state.renderMode = action.payload;
    },
    setRightPanel: (
      state,
      action: PayloadAction<ChatMessage<ChatMode> | null>
    ) => {
      state.rightPanel = action.payload;
    },
    setWorkflowInfo: (state, action: PayloadAction<WorkflowInfo | null>) => {
      state.workflowInfo = action.payload;
    },
    setIsStreaming: (state, action: PayloadAction<boolean>) => {
      state.isStreaming = action.payload;
    },
    setScrollToStep: (state, action: PayloadAction<number | null>) => {
      state.scrollToStep = action.payload;
    },
  },
});

const { reducer: chatModuleReducer, actions } = chatModuleSlice;

interface ChatModuleActions {
  setIsLoading: ActionCreatorWithPayload<boolean>;
  setRenderMode: ActionCreatorWithPayload<RenderModeType>;
  setRightPanel: ActionCreatorWithPayload<ChatMessage<ChatMode> | null>;
  setWorkflowInfo: ActionCreatorWithPayload<WorkflowInfo | null>;
  setIsStreaming: ActionCreatorWithPayload<boolean>;
  setScrollToStep: ActionCreatorWithPayload<number | null>;
}

export const chatModuleActions = actions as ChatModuleActions;

export default chatModuleReducer;
